import React, { useCallback, useState } from 'react';
import {
  createStyles,
  FormControl,
  InputLabel,
  ListItem,
  ListItemText,
  makeStyles,
  MenuItem,
  Select,
} from '@material-ui/core';

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      width: '100%',
    },
    mediaQuery: {
      // TODO:Material-UIのバージョン変更によって修正する可能性有り
      // Material-UIのMenuItemで定義されているメディアクエリを打ち消す
      // 常にminHeight:48
      [theme.breakpoints.up('sm')]: {
        minHeight: 48,
      },
    },
  }),
);

const SelectItem = React.memo(function SelectItem(props) {
  const { item, defaultValue = '', onChange, rootIdx, childIdx, grandChildIdx } = props;

  const classes = useStyles();

  const [value, setValue] = useState(defaultValue);

  const handleChangeSelect = useCallback(
    (e) => {
      setValue(e.target.value);

      onChange(rootIdx, childIdx, grandChildIdx, e.target.value);
    },
    [childIdx, grandChildIdx, onChange, rootIdx],
  );

  return (
    <ListItem dense>
      <ListItemText>
        <FormControl variant="outlined" className={classes.select}>
          <InputLabel>{item.name}</InputLabel>
          <Select value={value} onChange={handleChangeSelect} label={item.name}>
            {item.options.map((option, optionIdx) => (
              <MenuItem value={option} key={optionIdx} classes={{ root: classes.mediaQuery }}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ListItemText>
    </ListItem>
  );
});

SelectItem.displayName = 'SelectItem';

export default SelectItem;
